webpackJsonp([25],{

/***/ 1054:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomerReceiptDetail_vue__ = __webpack_require__(2628);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74fb2ec2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomerReceiptDetail_vue__ = __webpack_require__(3797);
function injectStyle (ssrContext) {
  __webpack_require__(3791)
  __webpack_require__(3793)
  this["$style"] = __webpack_require__(3795)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-74fb2ec2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomerReceiptDetail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74fb2ec2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomerReceiptDetail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1352:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1357), __esModule: true };

/***/ }),

/***/ 1355:
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(992))(78);

/***/ }),

/***/ 1357:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(234);
__webpack_require__(143);
module.exports = __webpack_require__(1358);


/***/ }),

/***/ 1358:
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(41);
var get = __webpack_require__(145);
module.exports = __webpack_require__(12).getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};


/***/ }),

/***/ 1360:
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(992))(77);

/***/ }),

/***/ 1364:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//download.js v4.2, by dandavis; 2008-2016. [MIT] see http://danml.com/download.html for tests/usage
// v1 landed a FF+Chrome compat way of downloading strings to local un-named files, upgraded to use a hidden frame and optional mime
// v2 added named files via a[download], msSaveBlob, IE (10+) support, and window.URL support for larger+faster saves than dataURLs
// v3 added dataURL and Blob Input, bind-toggle arity, and legacy dataURL fallback was improved with force-download mime and base64 support. 3.1 improved safari handling.
// v4 adds AMD/UMD, commonJS, and plain browser support
// v4.1 adds url download capability via solo URL argument (same domain/CORS only)
// v4.2 adds semantic variable names, long (over 2MB) dataURL support, and hidden by default temp anchors
// https://github.com/rndme/download


function download(data, strFileName, strMimeType, headers, finishCb) {

  var self = window,
      // this script is only for browsers anyway...
  defaultMime = "application/octet-stream",
      // this default mime also triggers iframe downloads
  mimeType = strMimeType || defaultMime,
      payload = data,
      url = !strFileName && !strMimeType && payload,
      anchor = document.createElement("a"),
      toString = function toString(a) {
    return String(a);
  },
      myBlob = self.Blob || self.MozBlob || self.WebKitBlob || toString,
      fileName = strFileName || "download",
      blob,
      reader;
  myBlob = myBlob.call ? myBlob.bind(self) : Blob;

  if (String(this) === "true") {
    //reverse arguments, allowing download.bind(true, "text/xml", "export.xml") to act as a callback
    payload = [payload, mimeType];
    mimeType = payload[0];
    payload = payload[1];
  }

  if (url && url.length < 2048) {
    // if no filename and no mime, assume a url was passed as the only argument
    fileName = url.split("/").pop().split("?")[0];
    anchor.href = url; // assign href prop to temp anchor
    // if(anchor.href.indexOf(url) !== -1){ // if the browser determines that it's a potentially valid url path:
    var ajax = new XMLHttpRequest();
    ajax.open("GET", url, true);
    ajax.responseType = 'blob';
    for (var _i in headers) {
      if (headers.hasOwnProperty(_i)) {
        ajax.setRequestHeader(_i, headers[_i]);
      }
      // }
      ajax.onload = function (e) {
        download(e.target.response, fileName, defaultMime, headers, finishCb);
      };
      setTimeout(function () {
        ajax.send();
      }, 0); // allows setting custom ajax headers using the return:
      return ajax;
    } // end if valid url?
  } // end if url?


  //go ahead and download dataURLs right away
  if (/^data:([\w+-]+\/[\w+.-]+)?[,;]/.test(payload)) {

    if (payload.length > 1024 * 1024 * 1.999 && myBlob !== toString) {
      payload = dataUrlToBlob(payload);
      mimeType = payload.type || defaultMime;
    } else {
      return navigator.msSaveBlob ? // IE10 can't do a[download], only Blobs:
      navigator.msSaveBlob(dataUrlToBlob(payload), fileName) : saver(payload); // everyone else can save dataURLs un-processed
    }
  } else {
    //not data url, is it a string with special needs?
    if (/([\x80-\xff])/.test(payload)) {
      var i = 0,
          tempUiArr = new Uint8Array(payload.length),
          mx = tempUiArr.length;
      for (i; i < mx; ++i) {
        tempUiArr[i] = payload.charCodeAt(i);
      }payload = new myBlob([tempUiArr], { type: mimeType });
    }
  }
  blob = payload instanceof myBlob ? payload : new myBlob([payload], { type: mimeType });

  function dataUrlToBlob(strUrl) {
    var parts = strUrl.split(/[:;,]/),
        type = parts[1],
        decoder = parts[2] == "base64" ? atob : decodeURIComponent,
        binData = decoder(parts.pop()),
        mx = binData.length,
        i = 0,
        uiArr = new Uint8Array(mx);

    for (i; i < mx; ++i) {
      uiArr[i] = binData.charCodeAt(i);
    }return new myBlob([uiArr], { type: type });
  }

  function saver(url, winMode) {

    if ('download' in anchor) {
      //html5 A[download]
      anchor.href = url;
      anchor.setAttribute("download", fileName);
      anchor.className = "download-js-link";
      anchor.innerHTML = "downloading...";
      anchor.style.display = "none";
      document.body.appendChild(anchor);
      setTimeout(function () {
        anchor.click();
        document.body.removeChild(anchor);
        if (winMode === true) {
          setTimeout(function () {
            self.URL.revokeObjectURL(anchor.href);
          }, 250);
        }
        if (finishCb) {
          finishCb();
        }
      }, 66);
      return true;
    }

    // handle non-a[download] safari as best we can:
    if (/(Version)\/(\d+)\.(\d+)(?:\.(\d+))?.*Safari\//.test(navigator.userAgent)) {
      if (/^data:/.test(url)) url = "data:" + url.replace(/^data:([\w\/\-\+]+)/, defaultMime);
      if (!window.open(url)) {
        // popup blocked, offer direct download:
        if (confirm("Displaying New Document\n\nUse Save As... to download, then click back to return to this page.")) {
          location.href = url;
        }
      }
      return true;
    }

    //do iframe dataURL download (old ch+FF):
    var f = document.createElement("iframe");
    document.body.appendChild(f);

    if (!winMode && /^data:/.test(url)) {
      // force a mime that will download:
      url = "data:" + url.replace(/^data:([\w\/\-\+]+)/, defaultMime);
    }
    f.src = url;
    setTimeout(function () {
      document.body.removeChild(f);
    }, 333);
  } //end saver


  if (navigator.msSaveBlob) {
    // IE10+ : (has Blob, but not a[download] or URL)
    return navigator.msSaveBlob(blob, fileName);
  }

  if (self.URL) {
    // simple fast and modern way using Blob and URL:
    saver(self.URL.createObjectURL(blob), true);
  } else {
    // handle non-Blob()+non-URL browsers:
    if (typeof blob === "string" || blob.constructor === toString) {
      try {
        return saver("data:" + mimeType + ";base64," + self.btoa(blob));
      } catch (y) {
        return saver("data:" + mimeType + "," + encodeURIComponent(blob));
      }
    }

    // Blob but not URL support:
    reader = new FileReader();
    reader.onload = function (e) {
      saver(this.result);
    };
    reader.readAsDataURL(blob);
  }
  return true;
}; /* end download() */

/* harmony default export */ __webpack_exports__["a"] = (download);

/***/ }),

/***/ 1441:
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(40);
var getKeys = __webpack_require__(101);
var toIObject = __webpack_require__(100);
var isEnum = __webpack_require__(235).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!DESCRIPTORS || isEnum.call(O, key)) {
        result.push(isEntries ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};


/***/ }),

/***/ 1445:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1446), __esModule: true };

/***/ }),

/***/ 1446:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1447);
module.exports = __webpack_require__(12).Object.values;


/***/ }),

/***/ 1447:
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(28);
var $values = __webpack_require__(1441)(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});


/***/ }),

/***/ 1513:
/***/ (function(module, exports, __webpack_require__) {

module.exports = function () {
  return new Worker(__webpack_require__.p + "2f6ec96fc704f66aecaa.worker.js");
};

/***/ }),

/***/ 2628:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_viewerjs_dist_viewer_css__ = __webpack_require__(1355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_viewerjs_dist_viewer_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_viewerjs_dist_viewer_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_viewerjs__ = __webpack_require__(1360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_viewerjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_viewerjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__vendor_download__ = __webpack_require__(1364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_auth__ = __webpack_require__(77);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  data: function data() {
    return {
      id: 0,
      form: {
        company_name: '',
        bank_info: '',
        address_phone: '',
        tax_number: '',
        attached_file: [],
        customer_ids: [],
        customer_infos: [],
        pay_condition_ids: [],
        pay_condition_infos: []
      },
      fileList: []
    };
  },

  computed: {},
  watch: {},
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      return vm.onLoad();
    });
  },
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    this.onReload();
    next();
  },
  created: function created() {},
  mounted: function mounted() {},

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, request.map(['getCustomerTable']), {
    onLoad: function onLoad() {
      if (this.$route.params.id) {
        this.setForm(this.id = this.$route.params.id);
      }
    },
    onReload: function onReload() {
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.$data, this.$options.data.call(this));
      this.onLoad();
    },
    setForm: function setForm(id) {
      var _this = this;

      request.common('getCustomerReceiptDetail', { id: id }).then(function (_ref) {
        var data = _ref.data;

        filter.setLoop(_this.form, data);
        _this.setCustomerInfo();
        _this.setCollectCondition();
      });
    },
    setCustomerInfo: function setCustomerInfo() {
      var _this2 = this;

      var customerInfos = [];
      request.common('getCustomerTable', { ids: this.form.customer_ids, type: 'all' }).then(function (_ref2) {
        var data = _ref2.data;

        _this2.form.customer_ids.forEach(function (id) {
          var target = data.data.find(function (el) {
            return el.id * 1 === id * 1;
          });
          if (target) {
            customerInfos.push(target);
          } else {
            customerInfos.push({ id: id, number: '-', name: '客户数据不存在，请检查是否被删除' });
          }
        });
        _this2.form.customer_infos = customerInfos;
      });
    },
    setCollectCondition: function setCollectCondition() {
      var _this3 = this;

      request.common('queryPayCondition', { id: this.form.pay_condition_ids }).then(function (_ref3) {
        var data = _ref3.data;

        _this3.form.pay_condition_infos = data.data;
      });
    },
    getCustomerInfoRemote: function getCustomerInfoRemote(id) {
      return request.common('getCustomerDetail', id);
    },
    onGetPdfFile: function onGetPdfFile(item) {
      var _this4 = this;

      this.$confirm('确认下载文件?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        Object(__WEBPACK_IMPORTED_MODULE_4__vendor_download__["a" /* default */])(request.items.getFinCenterFileUrlForDownload(item), false, false, {
          'SJ-Auth-Token': Object(__WEBPACK_IMPORTED_MODULE_5__utils_auth__["c" /* getToken */])()
        });
      }).catch(function () {
        _this4.$message({
          type: 'info',
          message: '下载已取消'
        });
      });
    },
    onViewImage: function onViewImage(event) {
      if (event.target.src) {
        this.views = new __WEBPACK_IMPORTED_MODULE_3_viewerjs___default.a(event.target, {
          url: function url(image) {
            return event.target.src;
          }
        });
      }
      this.views.view();
    }
  })
});

/***/ }),

/***/ 2629:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_CustomerReceiptBatchExcel_vue__ = __webpack_require__(3804);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: { CustomerReceiptBatchExcel: __WEBPACK_IMPORTED_MODULE_4__components_CustomerReceiptBatchExcel_vue__["a" /* default */] },
  data: function data() {
    return {
      form: {
        data: []
      },
      error_data: [],
      percentage: 0,
      file: null
    };
  },

  computed: {},
  watch: {},
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    this.onReload();
    next();
  },
  created: function created() {},
  mounted: function mounted() {},

  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, request.map([]), {
    onReload: function onReload() {
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(this.$data, this.$options.data.call(this));
      this.$refs.companyExcel.$refs.CustomerReceiptBatchExcel.clearFiles();
    },
    getBatchDemo: function getBatchDemo() {
      if (this.$route.meta.isUpdate) {
        this.exportUpdateDemo();
      } else {
        this.exportCreateDemo();
      }
    },
    exportCreateDemo: function exportCreateDemo() {
      var demo = [{
        'company_name': '上海妙可蓝多食品科技股份有限公司',
        'bank_info': '光大银行上海金桥支行76300188000235101',
        'address_phone': '上海市奉贤区工业路899号8幢13839354544',
        'tax_number': '1370000164102345',
        'customer_ids': '45646、45644',
        'pay_condition_ids': '1、4'
      }];
      this.$export('批量添加开票抬头信息 Demo', demo, { fileHeader: this.getDemoHeader(this.xlsxReqHeader()) });
    },
    exportUpdateDemo: function exportUpdateDemo() {
      var demo = [{
        'id': '2',
        'bank_info': '光大银行上海金桥支行76300188000235101',
        'address_phone': '上海市奉贤区工业路899号8幢13839354544',
        'customer_ids': '45646、45644',
        'pay_condition_ids': '1、4',
        'is_disabled': '启用中'
      }, {
        'id': '1',
        'bank_info': '光大银行上海金桥支行76300188000235101',
        'address_phone': '上海市奉贤区工业路899号8幢13839354544',
        'customer_ids': '45646、45644',
        'pay_condition_ids': '1、4',
        'is_disabled': '已禁用'
      }];
      this.$export('批量编辑开票抬头信息 Demo', demo, { fileHeader: this.getDemoHeader(this.xlsxReqHeader()) });
    },
    getFormData: function getFormData() {
      return filter.copyJson(this.form.data);
    },
    onSubmit: function onSubmit() {
      var data = this.getFormData();
      data = data.map(function (item) {
        item.attached_file = [];
        if (String(item.customer_ids).indexOf('、') !== -1) {
          item.customer_ids = item.customer_ids.split('、');
        } else {
          item.customer_ids = [item.customer_ids];
        }
        if (String(item.pay_condition_ids).indexOf('、') !== -1) {
          item.pay_condition_ids = item.pay_condition_ids.split('、');
        } else {
          item.pay_condition_ids = [item.pay_condition_ids];
        }
        return item;
      }).filter(function (item) {
        return item.customer_ids.length;
      });
      if (data.length === 0) {
        this.$message.error('请选择文件');
      } else {
        this.createOrUpdate(data);
      }
    },
    excelFileRemove: function excelFileRemove(fileList) {
      if (fileList.length === 0) {
        this.form.data = [];
      }
    },
    createOrUpdate: function createOrUpdate(data) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var index, param, num, info;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.error_data = [];
                index = 0;

              case 2:
                if (!(index < data.length)) {
                  _context.next = 24;
                  break;
                }

                param = data[index];
                num = index + 1;

                _this.percentage = num / data.length * 100;

                info = '第' + num + '行 ';

                if (!_this.checkParams(param, info)) {
                  _context.next = 21;
                  break;
                }

                _context.prev = 8;

                if (!_this.$route.meta.isUpdate) {
                  _context.next = 14;
                  break;
                }

                _context.next = 12;
                return request.loading('updateReceiptInfoData', param);

              case 12:
                _context.next = 16;
                break;

              case 14:
                _context.next = 16;
                return request.loading('createCustomerReceiptData', param);

              case 16:
                _context.next = 21;
                break;

              case 18:
                _context.prev = 18;
                _context.t0 = _context['catch'](8);

                _this.error_data.push(info + _context.t0.message);

              case 21:
                index++;
                _context.next = 2;
                break;

              case 24:
                if (_this.error_data.length === 0) {
                  _this.$confirm('上传成功，是否返回列表查看', '提示', { type: 'warning' }).then(function () {
                    _this.$router.back();
                  });
                }

              case 25:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[8, 18]]);
      }))();
    },
    checkParams: function checkParams(param, info) {
      var err = '';
      var reqHeader = this.xlsxReqHeader();
      for (var ruleKey in reqHeader) {
        if (param[ruleKey] === '') {
          err = reqHeader[ruleKey].text + ' 为空';
          break;
        }
      }
      // 转换请求参数数值
      this.convertParamValue(param, info, err);
      if (err) {
        this.error_data.push(info + err);
        return false;
      }
      return true;
    },
    convertParamValue: function convertParamValue(param, info, err) {
      if (param.hasOwnProperty('is_disabled')) {
        if (param.is_disabled === '启用中') {
          param.is_disabled = 0;
        } else if (param.is_disabled === '已禁用') {
          param.is_disabled = 1;
        } else {
          err = '禁用状态仅支持输入【启用中】、【已禁用】';
        }
      }
    },

    // 返回 excel 文件必须存在的表头字段
    xlsxReqHeader: function xlsxReqHeader() {
      if (this.$route.meta.isUpdate) {
        return {
          id: { index: null, text: '开票信息ID' },
          bank_info: { index: null, text: '开户银行及账户' },
          address_phone: { index: null, text: '地址及电话' },
          customer_ids: { index: null, text: '使用客户ID' },
          pay_condition_ids: { index: null, text: '账期ID' },
          is_disabled: { index: null, text: '禁用状态' }
        };
      } else {
        return {
          company_name: { index: null, text: '公司名称' },
          bank_info: { index: null, text: '开户银行及账户' },
          address_phone: { index: null, text: '地址及电话' },
          tax_number: { index: null, text: '税号' },
          customer_ids: { index: null, text: '使用客户ID' },
          pay_condition_ids: { index: null, text: '账期ID' }
        };
      }
    },
    getDemoHeader: function getDemoHeader(reqHeader) {
      var demoHeader = [];
      for (var key in reqHeader) {
        if (reqHeader.hasOwnProperty(key) && reqHeader[key].hasOwnProperty('text')) {
          demoHeader.push({ key: key, text: reqHeader[key].text });
        }
      }
      return demoHeader;
    }
  })
});

/***/ }),

/***/ 2630:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__ = __webpack_require__(1445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__(1352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__worker_read_xlsx_worker__ = __webpack_require__(1513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__worker_read_xlsx_worker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__worker_read_xlsx_worker__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var worker = new __WEBPACK_IMPORTED_MODULE_3__worker_read_xlsx_worker___default.a();
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  props: {
    xlsxReqHeader: Object
  },
  data: function data() {
    return {
      loading: false
    };
  },

  computed: {
    xlsxReqText: function xlsxReqText() {
      var text = [];
      var xlsxHead = _.cloneDeep(this.xlsxReqHeader);
      for (var key in xlsxHead) {
        if (xlsxHead.hasOwnProperty(key) && xlsxHead[key].hasOwnProperty('text')) {
          text.push(this.xlsxReqHeader[key].text);
        }
      }
      return text ? '【' + text.join('、') + '】' : '--';
    }
  },
  watch: {},
  created: function created() {},
  mounted: function mounted() {},

  methods: {
    getDemo: function getDemo() {
      this.$emit('getBatchDemo');
    },
    excelFileChange: function excelFileChange(file, fileList) {
      if (file.status === 'ready') {
        // 已上传文件列表如果存在 2 条记录，移除第一条，实现替换效果
        if (fileList.length >= 2) {
          fileList.shift();
        }
      }
    },
    excelFileRemove: function excelFileRemove(file, fileList) {
      this.$emit('excelFileRemove', fileList);
    },
    beforeFileUpload: function beforeFileUpload(file) {
      var isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error('选择文件大小不能超过 2MB!');
      }
      return isLt2M;
    },
    uploadRequest: function uploadRequest(obj) {
      var _this = this;

      this.loading = true;
      this.$emit('change-file', obj.file);
      worker.postMessage({ file: obj.file, options: { header: 1 } });
      worker.onmessage = function (event) {
        // 处理数据
        _this.handleExcelData(event.data);
        _this.loading = false;
      };
    },
    handleExcelData: function handleExcelData(rows) {
      var _this2 = this;

      rows = rows.filter(function (item) {
        return item.length;
      });
      var items = [];
      var tableHeader = this.xlsxReqHeader;
      try {
        rows.forEach(function (row, rowIndex) {
          var item = {};
          row.forEach(function (cell, cellIndex) {
            if (rowIndex) {
              // 获得数据行前 检查表头是否存在
              if (rowIndex === 1) {
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                  for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(tableHeader)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var header = _step.value;

                    if (!__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default()(header.index)) {
                      _this2.loading = false;
                      _this2.$refs.CustomerReceiptBatchExcel.clearFiles();
                      throw new Error('\u627E\u4E0D\u5230 [' + header.text + '] \u8868\u5934');
                    }
                  }
                } catch (err) {
                  _didIteratorError = true;
                  _iteratorError = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                      _iterator.return();
                    }
                  } finally {
                    if (_didIteratorError) {
                      throw _iteratorError;
                    }
                  }
                }
              }
              // 表格的行数据获取
              for (var field in tableHeader) {
                if (tableHeader.hasOwnProperty(field)) {
                  // 根据字段的 index 获得相应的值
                  if (cellIndex === tableHeader[field].index) {
                    item[field] = cell;
                  }
                }
              }
            } else {
              // 检查表头字段是否存在
              var _iteratorNormalCompletion2 = true;
              var _didIteratorError2 = false;
              var _iteratorError2 = undefined;

              try {
                for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(tableHeader)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                  var _header = _step2.value;

                  if (cell === _header.text) {
                    _header.index = cellIndex;
                  }
                }
              } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion2 && _iterator2.return) {
                    _iterator2.return();
                  }
                } finally {
                  if (_didIteratorError2) {
                    throw _iteratorError2;
                  }
                }
              }
            }
          });
          rowIndex && items.push(item);
        });
        this.$emit('change', items);
      } catch (e) {
        this.$alert(e.toString(), '提示', { type: 'error' });
        throw new Error(e);
      }
    }
  }
});

/***/ }),

/***/ 285:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomerReceiptBatchForm_vue__ = __webpack_require__(2629);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0bbccb10_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomerReceiptBatchForm_vue__ = __webpack_require__(3812);
function injectStyle (ssrContext) {
  __webpack_require__(3798)
  __webpack_require__(3800)
  this["$style"] = __webpack_require__(3802)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0bbccb10"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomerReceiptBatchForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0bbccb10_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomerReceiptBatchForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 3791:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3792);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("1f3b1d98", content, true, {});

/***/ }),

/***/ 3792:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"CustomerReceiptDetail.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 3793:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3794);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("71b278e4", content, true, {});

/***/ }),

/***/ 3794:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".view-navbar[data-v-74fb2ec2]{right:0;bottom:0;width:100%;overflow:hidden;display:inline;float:left}ul[data-v-74fb2ec2]{-webkit-transform:translateX(0);transform:translateX(0);-webkit-transition:all .3s;transition:all .3s;-webkit-box-sizing:content-box;box-sizing:content-box;overflow:hidden;padding:1px 0}li[data-v-74fb2ec2]{float:left;list-style:none;width:100px;height:100px;margin-right:5px;cursor:pointer;font-size:0;line-height:0;overflow:hidden;-webkit-transition:opacity .15s;transition:opacity .15s}", "", {"version":3,"sources":["/workspace/src/views/customer-receipt/pages/CustomerReceiptDetail.vue"],"names":[],"mappings":"AACA,8BAA8B,QAAU,SAAW,WAAW,gBAAgB,eAAe,UAAU,CACtG,AACD,oBAAoB,gCAAkC,wBAA0B,2BAA4B,mBAAoB,+BAA+B,uBAAuB,gBAAgB,aAAa,CAClN,AACD,oBAAoB,WAAW,gBAAgB,YAAY,aAAa,iBAAiB,eAAe,YAAY,cAAc,gBAAgB,gCAAiC,uBAAwB,CAC1M","file":"CustomerReceiptDetail.vue","sourcesContent":["\n.view-navbar[data-v-74fb2ec2]{right:0px;bottom:0px;width:100%;overflow:hidden;display:inline;float:left\n}\nul[data-v-74fb2ec2]{-webkit-transform:translateX(0px);transform:translateX(0px);-webkit-transition:all 0.3s;transition:all 0.3s;-webkit-box-sizing:content-box;box-sizing:content-box;overflow:hidden;padding:1px 0\n}\nli[data-v-74fb2ec2]{float:left;list-style:none;width:100px;height:100px;margin-right:5px;cursor:pointer;font-size:0;line-height:0;overflow:hidden;-webkit-transition:opacity 0.15s;transition:opacity 0.15s\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 3795:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3796);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("56a2f1e2", content, true, {});

/***/ }),

/***/ 3796:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"CustomerReceiptDetail.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 3797:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}]},[_c('div',{staticClass:"page-heading"},[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":"/"}},[_vm._v("首页")]),_vm._v(" "),_c('el-breadcrumb-item',{attrs:{"to":"/customer-receipt/table"}},[_vm._v("客户开票信息列表")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.$route.meta.title))])],1)],1),_vm._v(" "),_c('layout-panel',[_c('span',{attrs:{"slot":"header"},slot:"header"},[_vm._v("表单")]),_vm._v(" "),_c('el-form',{ref:"form",attrs:{"model":_vm.form,"size":"medium","label-width":"140px"}},[_c('div',{staticClass:"re-el-form__flex"},[_c('div',{staticClass:"medium"},[_c('el-form-item',{attrs:{"label":"公司名称","prop":"company_name"}},[_c('label',[_vm._v(_vm._s(_vm.form.company_name))])]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"开户行及账户","prop":"bank_info"}},[_c('label',[_vm._v(_vm._s(_vm.form.bank_info))])]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"地址及电话","prop":"address_phone"}},[_c('label',[_vm._v(_vm._s(_vm.form.address_phone))])]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"税号","prop":"tax_number"}},[_c('label',[_vm._v(_vm._s(_vm.form.tax_number))])]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"附件","prop":"attached_file"}},[_c('div',{staticClass:"view-navbar"},[_c('ul',{staticClass:"clear-both"},_vm._l((_vm.form.attached_file),function(item,index){return _c('li',{key:index},[_c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":item.name,"placement":"bottom"}},[(item.type === 'pic')?_c('img',{staticStyle:{"width":"100px","height":"100px"},attrs:{"src":item.tmp_url},on:{"click":_vm.onViewImage}}):_vm._e(),_vm._v(" "),(item.type === 'pdf' || item.type === 'eml')?_c('i',{staticClass:"sj-icon-pdf",staticStyle:{"font-size":"100px","margin-top":"50px"},on:{"click":function($event){return _vm.onGetPdfFile(item, index)}}}):_vm._e()])],1)}),0)])]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"使用客户","prop":"customer_infos"}},_vm._l((_vm.form.customer_infos),function(item,index){return _c('div',{key:index,staticClass:"market"},[_c('label',[_vm._v(_vm._s(index + 1)+"、 "+_vm._s(item.name)+" / "+_vm._s(item.number)+" / "+_vm._s(item.id))])])}),0),_vm._v(" "),_c('el-form-item',{attrs:{"label":"账期","prop":"pay_condition_ids"}},_vm._l((_vm.form.pay_condition_infos),function(item,index){return _c('div',{key:index,staticClass:"market"},[_c('label',[_vm._v(_vm._s(index + 1)+"、 "+_vm._s(item.name)+" / "+_vm._s(item.id))])])}),0)],1)]),_vm._v(" "),_c('el-form-item',[_c('el-button',{on:{"click":function($event){return _vm.$router.back()}}},[_vm._v("返回")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 3798:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3799);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("2a8eada0", content, true, {});

/***/ }),

/***/ 3799:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"CustomerReceiptBatchForm.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 3800:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3801);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("c3212b7c", content, true, {});

/***/ }),

/***/ 3801:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"CustomerReceiptBatchForm.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 3802:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3803);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("2756bb2c", content, true, {});

/***/ }),

/***/ 3803:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"CustomerReceiptBatchForm.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 3804:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomerReceiptBatchExcel_vue__ = __webpack_require__(2630);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_208d7840_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomerReceiptBatchExcel_vue__ = __webpack_require__(3811);
function injectStyle (ssrContext) {
  __webpack_require__(3805)
  __webpack_require__(3807)
  this["$style"] = __webpack_require__(3809)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-208d7840"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomerReceiptBatchExcel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_208d7840_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomerReceiptBatchExcel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 3805:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3806);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("aa79fc64", content, true, {});

/***/ }),

/***/ 3806:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"CustomerReceiptBatchExcel.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 3807:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3808);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("14888900", content, true, {});

/***/ }),

/***/ 3808:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "a[data-v-208d7840]{margin-right:10px;margin-bottom:10px}.re-el-upload-width-max[data-v-208d7840] .el-upload-dragger{height:200px}", "", {"version":3,"sources":["/workspace/src/views/customer-receipt/components/CustomerReceiptBatchExcel.vue"],"names":[],"mappings":"AACA,mBAAmB,kBAAkB,kBAAkB,CACtD,AACD,4DAA4D,YAAY,CACvE","file":"CustomerReceiptBatchExcel.vue","sourcesContent":["\na[data-v-208d7840]{margin-right:10px;margin-bottom:10px\n}\n.re-el-upload-width-max[data-v-208d7840] .el-upload-dragger{height:200px\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 3809:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3810);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("30601478", content, true, {});

/***/ }),

/***/ 3810:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"CustomerReceiptBatchExcel.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 3811:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-upload',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],ref:"CustomerReceiptBatchExcel",staticClass:"re-el-upload-width-max",attrs:{"drag":"","action":"","accept":".xlsx","on-remove":_vm.excelFileRemove,"on-change":_vm.excelFileChange,"before-upload":_vm.beforeFileUpload,"http-request":_vm.uploadRequest}},[_c('i',{staticClass:"el-icon-upload"}),_vm._v(" "),_c('div',{staticClass:"el-upload__text"},[_vm._v("将文件拖到此处，或"),_c('em',[_vm._v("点击选择文件")]),_vm._v(" "),_c('br'),_vm._v("\n    只能选择Microsoft Office Excel文件，且不超过2MB")]),_vm._v(" "),_c('div',{staticClass:"el-upload__tip",staticStyle:{"margin-top":"0"},attrs:{"slot":"tip"},slot:"tip"},[_vm._v("\n    Excel必须包含表头 "+_vm._s(_vm.xlsxReqText)+" "),_c('br'),_vm._v("\n    所有字段值不得为空 "),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"javascript:void(0);"},on:{"click":_vm.getDemo}},[_vm._v("下载Demo")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 3812:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}]},[_c('div',{staticClass:"page-heading"},[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":"/"}},[_vm._v("首页")]),_vm._v(" "),_c('el-breadcrumb-item',{attrs:{"to":"/customer-receipt/table"}},[_vm._v("客户开票信息列表")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.$route.meta.title))])],1)],1),_vm._v(" "),_c('layout-panel',[_c('span',{attrs:{"slot":"header"},slot:"header"},[_vm._v("表单")]),_vm._v(" "),_c('el-form',{ref:"form",attrs:{"model":_vm.form,"size":"medium","label-width":"140px"},nativeOn:{"submit":function($event){$event.preventDefault();return _vm.onSubmit()}}},[_c('div',{staticClass:"re-el-form__flex"},[_c('div',{staticClass:"medium"},[_c('el-form-item',{attrs:{"label":"选择Excel"}},[_c('CustomerReceiptBatchExcel',{ref:"companyExcel",attrs:{"xlsxReqHeader":this.xlsxReqHeader()},on:{"getBatchDemo":_vm.getBatchDemo,"excelFileRemove":_vm.excelFileRemove,"change-file":function (_) { return this$1.file = _; },"change":function (_) { return this$1.form.data = _; }}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"上传进度"}},[_c('div',{staticStyle:{"margin-top":"8px"}},[(_vm.percentage < 100)?_c('el-progress',{attrs:{"percentage":_vm.percentage,"stroke-width":18,"color":"#666666"}}):_vm._e(),_vm._v(" "),(_vm.percentage === 100)?_c('el-progress',{attrs:{"percentage":100,"stroke-width":18,"status":"success"}}):_vm._e()],1)]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"错误记录"}},[_vm._l((_vm.error_data),function(item){return _c('div',[_c('span',[_vm._v(_vm._s(item))])])})],2)],1)]),_vm._v(" "),_c('el-form-item',[_c('el-button',{attrs:{"type":"primary","native-type":"submit"}},[_vm._v("开始上传\n        ")]),_vm._v(" "),_c('el-button',{on:{"click":_vm.onReload}},[_vm._v("重置")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/customer-receipt-detail.cb7d8b4dd129d3286e19.js